<template>
  <!-- 申请详情页 -->
  <div class="apply-detail">
    <!-- 基本信息 -->
    <base-info :base-info="baseInfo" :schema="BASE_INFO_SCHEMA" />

    <!-- 申请明细 -->
    <a-card title="限额延期申请">
      <a-row>
        <a-skeleton active :loading="skeletonLoding">
          <contact-info
            ref="contactInfo"
            v-if="limitAmount"
            :limit-amount="limitAmount"
            :skeletonLoding="skeletonLoding"
            @hanleDetail="_limitAmount"
          ></contact-info>
        </a-skeleton>
      </a-row>
    </a-card>

    <!-- 提交 -->
    <footer-tool-bar>
      <a-button @click="goBack" style="margin: 0px 20px">返回上一级</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import { BASE_INFO_SCHEMA, BASE_INFO_EXTRA_SCHEMA } from '../../schema'
import BaseInfo from '../../components/BaseInfo'
import numeral from 'numeral'
// import ApplyViewDetail from './ApplyViewDetail.vue'
import { APPROVAL_STATUS_VALUE_OBJ } from '../../const'
import FooterToolBar from 'components/FooterToolBar.vue'
import { selectCompany, getAmountDetail } from '../api'
import storage from 'good-storage'
import ContactInfo from './ContactInfo.vue'

export default {
  name: 'apply-detail-page',
  data() {
    return {
      BASE_INFO_SCHEMA,
      loading: true,
      id: '',
      type: '',
      status: '',
      baseInfo: {}, // 基本信息
      creditInfo: null, // 申请明细
      limitAmount: {}, // 信用限额表格
      riskEvaluation: '',
      skeletonLoding: true,
    }
  },
  computed: {
    // 详情信息schema
    baseInfoSchema() {
      const status = this.status
      if (
        status == APPROVAL_STATUS_VALUE_OBJ.INIT ||
        status == APPROVAL_STATUS_VALUE_OBJ.PADDING ||
        status == APPROVAL_STATUS_VALUE_OBJ.PASSED
      ) {
        return Object.assign({}, BASE_INFO_SCHEMA, BASE_INFO_EXTRA_SCHEMA)
      }
      return BASE_INFO_SCHEMA
    },
  },
  created() {
    const { type } = this.$route.query
    const { companyCode } = this.$route.params
    if (companyCode) {
      this.companyCode = companyCode
      this.getBaseInfo(companyCode)
      this.type = type
    }
  },

  methods: {
    //查询公司限额信息
    _limitAmount() {
      getAmountDetail(this.companyCode).then(({ data }) => {
        this.limitAmount = data
        this.skeletonLoding = false
        console.log(3333, this.limitAmount)
      })
    },

    resetAmount(num) {
      return numeral(num).format('0.00')
    },
    async getBaseInfo(companyCode) {
      try {
        const { data } = await selectCompany(companyCode)
        const minus =
          Number(this.resetAmount(data.totalCreditLimit)) -
          Number(data.groupTotalAmount)
        data.groupExposure = minus
        this.baseInfo = data
        if (this.baseInfo.companyType === 1) {
          delete this.baseInfo.exposure
        } else {
          delete this.baseInfo.groupExposure
        }
        storage.set('baseInfoList', this.baseInfo)
      } catch (error) {
        console.error(error)
      }
    },

    async handleSubmit() {
      try {
        const values = await Promise.all([
          this.$refs.applyEditDetail.validate(),
          this.$refs.selectApproval.validate(),
        ])
        const allPassed = values.every(value => !!value)
        if (allPassed) {
          let params = { companyCode: this.companyCode, type: this.type }
          values.forEach(item => Object.assign(params, item))
          // 对params做处理
          params = this.assembleParams(params)
          console.log(params)
          this.doApply(params)
        }
      } catch (error) {
        console.error(error)
      }
    },

    goBack() {
      this.$router.go(-1)
    },
  },

  components: {
    FooterToolBar,
    BaseInfo,
    // ApplyViewDetail,
    ContactInfo,
  },
  mounted() {
    this._limitAmount()
  },
}
</script>

<style></style>
